import React from 'react';
import PropTypes from 'prop-types';

import { wrapperStyle, contentStyle, bellIconStyle, closeIconStyle } from './styles';

function colorify(str, defaultColor) {
  if (str.length < 1) return defaultColor;
  if (str.substr(0, 1) === '#') return `#${str.substr(1, 6)}`;
  else return `#${str.substr(0, 6)}`;
}

export class TopSticky extends React.PureComponent {
  static propTypes = {
    content: PropTypes.string.isRequired,
    color: PropTypes.string,
    bgColor: PropTypes.string,
    onClose: PropTypes.func,
  };

  render() {
    const { content, color, bgColor, onClose } = this.props;

    return (
      <div className={wrapperStyle(colorify(bgColor, '000000'))}>
        <div className={bellIconStyle}/>
        <div className={contentStyle(colorify(color, 'ffffff'))} dangerouslySetInnerHTML={{ __html: content }}/>
        <div className={closeIconStyle} onClick={onClose} />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/shared/topSticky/component.js